import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/Zebra'

const ZEBRA: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'ZEBRA CRM プッシュ通知 配信'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/services/zebra/'}
        title="ZEBRA | サービス | i3DESIGN アイスリーデザイン"
        description="ZEBRAは、CRMと顧客属性DBを活用し、高度なセグメント配信を実現します。全件配信、セグメント配信、リスト配信など多彩な方法に加え、プッシュ通知で顧客のニーズに合わせた最適なメッセージを迅速に届けることが可能です。これにより、顧客体験の向上と効果的なコミュニケーションが実現します。"
      />
      <Template />
    </>
  )
}

export default ZEBRA
